import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faArrowLeft,
    faArrowRotateRight,
    faArrowsRotate,
    faBell,
    faBolt,
    faCalendar,
    faCalendarCheck,
    faCalendarDay,
    faCalendarDays,
    faCalendarPlus,
    faCalendarXmark,
    faChartBar,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleXmark,
    faClipboardList,
    faClock,
    faCloudArrowUp,
    faEnvelope,
    faFilePen,
    faFilter,
    faGear,
    faHourglassEnd,
    faHouse,
    faKey,
    faList,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMedal,
    faMessage,
    faPaperPlane,
    faPen,
    faPenToSquare,
    faPlugCircleXmark,
    faPlus,
    faQrcode,
    faRightFromBracket,
    faRightToBracket,
    faRotate,
    faRotateRight,
    faShieldHalved,
    faSpinner,
    faTrash,
    faTriangleExclamation,
    faTrophy,
    faUser,
    faUserSlash,
    faUsers,
    faWifi,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faArrowLeft,
    faArrowRotateRight,
    faArrowsRotate,
    faBell,
    faBolt,
    faCalendar,
    faCalendarCheck,
    faCalendarDay,
    faCalendarDays,
    faCalendarPlus,
    faCalendarXmark,
    faChartBar,
    faChartPie,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleXmark,
    faClipboardList,
    faClock,
    faCloudArrowUp,
    faEnvelope,
    faFilePen,
    faFilter,
    faGear,
    faHourglassEnd,
    faHouse,
    faKey,
    faList,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMedal,
    faMessage,
    faPaperPlane,
    faPen,
    faPenToSquare,
    faPlugCircleXmark,
    faPlus,
    faQrcode,
    faRightFromBracket,
    faRightToBracket,
    faRotate,
    faRotateRight,
    faShieldHalved,
    faSpinner,
    faTrash,
    faTriangleExclamation,
    faTrophy,
    faUser,
    faUserSlash,
    faUsers,
    faWifi,
    faXmark,
);

dom.watch();
